"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 ", ";\n  border: ", ";\n  background: ", ";\n  border-radius: 0.1em;\n  box-shadow: ", ";\n  margin: 0 0.25em;\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Key = void 0;

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var isMac = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Mac OS X') !== -1;

function Key(_a) {
  var isCtrl = _a.isCtrl,
      children = _a.children,
      rest = __rest(_a, ["isCtrl", "children"]);

  return react_1.default.createElement(Container, Object.assign({
    children: isCtrl ? isMac ? '⌘' : 'ctrl' : children
  }, rest));
}

exports.Key = Key;
var Container = styledTypes_1.styled.span(_templateObject(), function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@shadow-small'];
});